import React from 'react'
import navigationController from './navigationController'

const ModalProvider: React.FC = ({
  children
}) =>
  <navigationController.Provider>
    {children}
  </navigationController.Provider>

export default ModalProvider
